export default __webpack_public_path__ + "static/media/shears-scarecrow--240.904848da.jpg";